import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { SocialLink, SocialLinkService } from '@/models'

import { useInvalidateSocialLinks } from './get-social-links'

export type AddSocialLinkRequest = {
  buildingId: number
  service: SocialLinkService
  link: string
}

export const addSocialLink = async (data: AddSocialLinkRequest): Promise<SocialLink> => {
  const response = await authAPI.post<SocialLink>('/sociallink', data)
  return response.data
}

export const useAddSocialLink = () => {
  const invalidate = useInvalidateSocialLinks()

  return useMutation({
    mutationFn: addSocialLink,
    onSuccess: invalidate,
  })
}
